module.exports = __webpack_public_path__ + "static/media/5ed7a32b72f4e5e57a74878a.071c8cc0.png";